export const APP_DLG_ID = "appDialogBox";
export const APP_SPINNER_ID = "appSpinnerId";